import axios from 'axios';

let API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// 根本修复：如果 baseURL 已经是 /api，前端调用路径也带 /api，会导致 /api/api/xxx 重复
// 当 API_URL 以 /api 结尾时，baseURL 设为空，由前端调用路径自带 /api 前缀
if (API_URL === '/api' || API_URL.endsWith('/api')) {
  API_URL = '';
}

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
